<template>
  <v-card class="d-flex flex-column" style="height: 90vh !important; overflow: hidden">
    <v-card-title class="dialog-header-footer">
      <span class="text-h5 pl-2 pb-2">Selektion Dienstteile</span>
    </v-card-title>
    <!--    <div class="d-flex border-red full-width flex-grow-1">content</div>-->
    <v-card-text>
      <!-- Selection of employee / duty on selected day if no duty has been found for the current user -->
      <div class="d-flex flex-column justify-start">
        <div class="text-subtitle-1 py-3 align-center">
          <!--          Am <b>{{ formattedDay }}</b> wurden keine Dienste oder Dienststücke für <b>{{ resolvedUserFromVbzNr }}</b> gefunden-->
          <div class="d-flex items-center">
            <!--            <div class="d-flex">Sie können einen anderen Tag mit Diensten wählen</div>-->
            <div v-if="dateSelectionEnabled" class="d-flex align-center">
              <v-select
                v-model="selectedDate"
                style="width: 250px"
                class="mx-2"
                hide-details
                outlined
                dense
                label="Datum"
                item-value="isoString"
                item-text="formatted"
                :items="daysWithDutiesFormatted"
                >verfügbare Tage
              </v-select>
            </div>
          </div>
        </div>
      </div>
    </v-card-text>
    <div style="flex: 1; overflow-y: scroll" class="d-flex flex-column">
      <div class="d-flex col-12 overflow-hidden">
        <div class="d-flex flex-column col-12 col-md-5 overflow-hidden" style="flex: 1; border-right: 1px solid grey">
          <div v-if="dutyActivities.length > 0">{{ mx_formatUser(selectedUser) }}</div>
          <duty-user-selection
            class="d-flex overflow-hidden"
            :filter="currentVbzNr ? mx_formatUserFromCompanyNr(currentVbzNr) : ''"
            :duties="duties"
            @onUserDutySelected="onUserDutySelected"
          ></duty-user-selection>
        </div>
        <!--        </div>-->
        <div class="d-flex flex-column col-12 col-md-7" style="overflow-y: auto">
          <div v-if="dutyActivities.length > 0" class="text--subtitle-1 py-4">Bitte 'von', 'bis' oder 'Umlaufstück' zur Dienstabschnitt-Selektion anwählen</div>

          <duty-parts-selection
            class="d-flex flex-grow-1"
            @save="onDutySelected"
            @cancel="cancel"
            :vbzNr="`${currentVbzNr}`"
            :day="day"
            :duty-activities="resolvedDutyActivities"
            :duty="selectedDuty"
            :duty-name="selectedDuty && selectedDuty.dutyname"
            :numberOfUsedItems="2"
          ></duty-parts-selection>
        </div>
      </div>
    </div>
  </v-card>
</template>
<script>
import { mapState } from 'vuex';
import api from '@/modules/customerVbzWorksheet/api';
import dateUtils from '@/common/dateUtils';
import configMixin from '@/mixins/configMixin';
import wsMixin from '@/modules/customerVbzWorksheet/wsMixin';
import DutyUserSelection from '@/modules/customerVbzWorksheet/components/DutyUserSelection.vue';
import DutyPartsSelection from '@/modules/customerVbzWorksheet/components/DutyPartsSelection.vue';
import { vbzAggregationRules } from '@/modules/customerVbzWorksheet/components/DutyAggregationRules';
import dutyAggregationService from '@/modules/customerVbzWorksheet/components/DutyAggregationService';

const debug = false;
export default {
  name: 'DutyLookup',
  components: { DutyPartsSelection, DutyUserSelection },
  mixins: [configMixin, wsMixin],
  props: {
    vbzNr: { type: String },
    vbzNrAttribute: String,
    day: Date,
    numberOfUsedItems: { type: Number, default: 1 }, // From a normal edit form, the user can select only one part
  },
  async mounted() {
    await this.loadEmployeesWithDuties();
    await this.loadDaysWithDuties();
    this.selectedDate = this.deriveSelectedDate(this.day);
    console.debug('fetchDutiesAndDutyActivities onMounted');
    await this.fetchDutiesAndDutyActivities();
  },
  data() {
    return {
      dateSelectionEnabled: false,
      daysWithDuties: [],
      currentVbzNr: this.vbzNr,
      currentDay: this.day,
      duties: [],
      dutyActivities: [],
      employeeNrsWithDuties: [],
      selectedDuty: null,

      dutiesByDay: [],
      startSelectionsCount: 0,
      endSelectionsCount: 0,
      startSelections: [],
      endSelections: [],
      startSelectionIndices: [],
      endSelectionIndices: [],
      startEndDutyActivities: {
        0: { start: null, end: null },
        1: { start: null, end: null },
      },

      selectedUser: null,
      selectedDate: null,
    };
  },
  computed: {
    ...mapState('vbzWorksheet', ['users', 'userByEmployeeNr', 'userByCompanyNr', 'dutyStopsById']),

    resolvedDutyActivities() {
      const dutyActivities = this.dutyActivities.map((da) => {
        return {
          // ...da,
          dutyname: da.dutyname,
          blockcode: da.blockcode,
          line: da.line,
          course: da.course,
          longName: da.longName,
          shortName: da.shortName ? da.shortName : null,
          activityLongname: da.activityLongname,
          activityShortname: da.activityShortname,
          fzgNummer: da.fzgNummer,
          fromMinutesAfterMidnight: da.fromMinutesAfterMidnight,
          toMinutesAfterMidnight: da.toMinutesAfterMidnight,
          from: this.time(da.fromMinutesAfterMidnight),
          fromLocation: this.getLocation(da.startStopIdFk),
          to: this.time(da.toMinutesAfterMidnight),
          startStopIdFk: da.startStopIdFk,
          endStopIdFk: da.endStopIdFk,
          toLocation: this.getLocation(da.endStopIdFk),
          _start: false,
          _end: false,
        };
      });
      if (debug) console.debug('resolvedDutyActivities before aggregation:', dutyActivities);
      const aggregatedDA = this.processDutyActivities(dutyActivities);
      if (debug) console.debug('resolvedDutyActivities after aggregation:', aggregatedDA);
      return aggregatedDA;
    },
    resolvedUserFromVbzNr() {
      let user = this.userByCompanyNr[this.currentVbzNr];
      if (user) return this.mx_formatUser(user);
      return this.currentVbzNr;
    },

    starts() {
      return this.duty;
    },

    daysWithDutiesFormatted() {
      return [{ isoString: null, formatted: 'beliebig' }].concat(
        this.daysWithDuties.map((dayIsoString) => {
          let formatted = dayIsoString;
          let d = new Date(dayIsoString);
          if (d.getMonth) {
            formatted = d.toLocaleDateString();
          }
          return { isoString: dayIsoString, formatted };
        })
      );
    },
  },
  methods: {
    getLocation(locationId) {
      let location = this.dutyStopsById[locationId];
      return location && location.shortname ? location.shortname.substring(0, 4) : null;
    },
    time(minutesAfterMidnight) {
      return dateUtils.getTimeFromMinutesAfterMidnight(this.configuredTimeFormat, minutesAfterMidnight);
    },
    deriveSelectedDate(day) {
      let localeDateString;
      if (day.getTime) {
        localeDateString = day.toLocaleDateString();
        // return { isoString: day.toISOString(), formatted:day.toLocaleDateString() };
      }
      let finding = this.daysWithDutiesFormatted.find((item) => item.formatted === localeDateString);
      console.debug('deriveSelectedDate daysWithDuties', this.daysWithDutiesFormatted, localeDateString, 'finding', finding);

      return finding ? finding.isoString : null;
    },
    onDutySelected(selection) {
      selection.dutyDetailsDateOfSelection = new Date().toISOString();
      this.$emit('onDutySelected', selection);
    },
    cancel() {
      this.$emit('cancel');
    },
    async onUserDutySelected(duty) {
      const companynr = this.mx_resolveEmployeeNrToCompanyNr(duty.employeenr);
      console.debug(`onUserDutySelected ${JSON.stringify(duty, null, 2)} $vbzNr=${companynr}`);

      await this.fetchDutyActivities(duty.id);
      this.selectedDuty = duty;
      this.currentVbzNr = companynr;
    },
    async loadEmployeesWithDuties() {
      let response = await api.fetchEmployeeNrsWithDuties();
      this.employeeNrsWithDuties = response.data.map((d) => d.employeenr);
    },
    async loadDaysWithDuties() {
      console.debug('loadDaysWithDuties');
      let daysWithDuties = await api.fetchDaysWithDuties();
      this.daysWithDuties = daysWithDuties.data;
    },

    /**
     * Fetch list of duties. If one duty is selected, the dutyActivities get loaded
     */
    async fetchDutiesAndDutyActivities() {
      let response;
      console.debug('fetchDutiesAndDutyActivities currentDay', this.currentDay, 'currentVbzNr', this.currentVbzNr);
      if (this.currentDay) {
        response = await api.fetchDutiesByDay(dateUtils.formatDateAsYYYYMMDD(this.currentDay));
      } else if (this.currentVbzNr) {
        response = await api.fetchDutiesByCompanyNr(this.currentVbzNr);
      }
      if (response) {
        this.duties = response.data;
      }

      if (this.currentDay && this.currentVbzNr) {
        // try loading the current duty => dutyActivities
        console.debug(`try loading the current duty => dutyActivities ${this.currentDay} currentVbzNr=${this.currentVbzNr}`);
        await this.fetchDutyActivitiesByCompanyNrAndDay(this.currentVbzNr, dateUtils.formatDateAsYYYYMMDD(this.currentDay));
      }
    },
    async fetchDutyActivities(dutyId) {
      console.debug('fetchDutyActivities');
      let response = await api.fetchDutyActivities(dutyId);
      this.dutyActivities = response.data;
      // this.dutyActivities = this.processDutyActivities(response.data);
    },
    async fetchDutyActivitiesByCompanyNrAndDay(companyNr, dayYYYYMMDD) {
      console.debug('fetchDutyActivitiesByCompanyNrAndDay');
      let response = await api.fetchDutyActivitiesByCompanyNrAndDay(companyNr, dayYYYYMMDD);
      this.dutyActivities = response.data;
    },

    processDutyActivities(dutyActivities) {
      return dutyAggregationService.processDutyActivities(vbzAggregationRules, dutyActivities);
    },
  },
  watch: {
    // async selectedUser(newValue, oldValue) {
    //   console.debug('selectedUser changed', newValue);
    //   this.currentVbzNr = newValue;
    //   console.debug(`fetchDutiesAndDutyActivities selectedUser changed from ${oldValue} to ${newValue}`)
    //   await this.fetchDutiesAndDutyActivities();
    // },
    // async day(newValue, oldValue) {
    //   console.debug('day changed', newValue, oldValue);
    //   this.currentDay = newValue;
    //   this.selectedDate = this.deriveSelectedDate(newValue);
    //   console.debug('this.selectedDate', this.selectedDate, newValue);
    //   console.debug(`fetchDutiesAndDutyActivities on day changed from ${oldValue} to ${newValue}`)
    //   await this.fetchDutiesAndDutyActivities();
    // },
    // async selectedDate(newValue,oldValue) {
    //   console.debug('selectedDate changed', newValue);
    //   this.currentDay = newValue ? new Date(newValue) : null;
    //   console.debug(`fetchDutiesAndDutyActivities on day selectedDate from ${oldValue} to ${newValue}`)
    //   await this.fetchDutiesAndDutyActivities();
    // },
  },
};
</script>
